module.exports = __webpack_public_path__ + "static/media/11.12b1b3a7.jpg";